import { Injectable } from "@angular/core"
import { Actions, Effect } from "@ngrx/effects"
import { Action } from "@ngrx/store"
import { Booking } from "@models/booking";
import { Observable } from "rxjs/Observable"
import { TutorTimeslots } from "@models/tutor-timeslots";
import {
  BookingService,
  TimeslotsParams,
  AffectedBookingsParams,
  DeleteBookingParams,
  BookingPotentialStudentsParams
} from "@services/booking";
import {
  FETCH_TIMESLOTS,
  FETCH_TIMESLOTS_FAILURE,
  POPULATE_TIMESLOTS,
  CREATE_BOOKING,
  ADD_BOOKING,
  CREATE_BOOKING_FAILURE,
  UPDATE_BOOKING,
  REPLACE_BOOKING,
  UPDATE_BOOKING_FAILURE,
  FETCH_AFFECTED_BOOKINGS,
  POPULATE_AFFECTED_BOOKINGS,
  FETCH_AFFECTED_BOOKINGS_FAILURE,
  DELETE_BOOKING_FAILURE,
  REMOVE_BOOKING,
  DELETE_BOOKING,
  SAME_DAY_CANCEL_BOOKING_FAILURE,
  SAME_DAY_CANCEL_BOOKING,
  FETCH_POTENTIAL_BOOKING_STUDENTS,
  POPULATE_POTENTIAL_BOOKING_STUDENTS,
  FETCH_POTENTIAL_BOOKING_STUDENTS_FAILURE,
  FETCH_REPLACEMENT_TUTORS,
  FETCH_REPLACEMENT_TUTORS_FAILURE,
  POPULATE_REPLACEMENT_TUTORS
} from "../bookings";
import { Contact } from "@models/contact";
import { ContactSearchParams, ContactService } from "@services/contact";

@Injectable()
export class BookingEffects {

  constructor(
    private actions: Actions,
    private bookingService: BookingService,
    private contactService: ContactService,
  ) {}

  @Effect() create = this.actions
    .ofType(CREATE_BOOKING)
    .map((action: Action) => action.payload)
    .switchMap((b: Booking) => this.bookingService.create(b)
      .map((b: Booking) => ({ type: ADD_BOOKING, payload: b }))
      .catch(() => Observable.of({ type: CREATE_BOOKING_FAILURE }))
    )
    .share()

  @Effect() update = this.actions
    .ofType(UPDATE_BOOKING)
    .map((action: Action) => action.payload)
    .switchMap((b: Booking) => this.bookingService.update(b)
      .map((b: Booking) => ({ type: REPLACE_BOOKING, payload: b }))
      .catch(() => Observable.of({ type: UPDATE_BOOKING_FAILURE }))
    )
    .share()

  @Effect() timeslots = this.actions
    .ofType(FETCH_TIMESLOTS)
    .debounceTime(500)
    .map((action: Action) => action.payload)
    .switchMap((params: TimeslotsParams) => this.bookingService.timeslots(params)
      .map((ts: TutorTimeslots[]) => ({ type: POPULATE_TIMESLOTS, payload: ts }))
      .catch(() => Observable.of({ type: FETCH_TIMESLOTS_FAILURE }))
    )
    .share()

  @Effect() potentialStudents = this.actions
    .ofType(FETCH_POTENTIAL_BOOKING_STUDENTS)
    .debounceTime(300)
    .map((action: Action) => action.payload)
    .switchMap((params: BookingPotentialStudentsParams) => this.bookingService.potentialStudents(params)
      .map((payload: Contact[]) => ({ type: POPULATE_POTENTIAL_BOOKING_STUDENTS, payload }))
      .catch(() => Observable.of({ type: FETCH_POTENTIAL_BOOKING_STUDENTS_FAILURE }))
    )
    .share()

  @Effect() replacementTutors = this.actions
    .ofType(FETCH_REPLACEMENT_TUTORS)
    .debounceTime(300)
    .map((action: Action) => action.payload)
    .switchMap(() => this.contactService.index({ has_tutor_allocation: true })
      .map((payload: Contact[]) => ({ type: POPULATE_REPLACEMENT_TUTORS, payload }))
      .catch(() => Observable.of({ type: FETCH_REPLACEMENT_TUTORS_FAILURE }))
    )
    .share()

  @Effect() affectedBookings = this.actions
    .ofType(FETCH_AFFECTED_BOOKINGS)
    .map((action: Action) => action.payload)
    .switchMap((params: AffectedBookingsParams) => this.bookingService.affectedBookings(params)
      .map((bookings: Booking[]) => ({ type: POPULATE_AFFECTED_BOOKINGS, payload: bookings }))
      .catch(() => Observable.of({ type: FETCH_AFFECTED_BOOKINGS_FAILURE }))
    )
    .share()

  @Effect() remove = this.actions
    .ofType(DELETE_BOOKING)
    .map((action: Action) => action.payload)
    .switchMap((params: DeleteBookingParams) => this.bookingService.remove(params)
      .map(() => ({ type: REMOVE_BOOKING }))
      .catch(() => Observable.of({ type: DELETE_BOOKING_FAILURE }))
    )
    .share()

  @Effect() sameDayCancel = this.actions
    .ofType(SAME_DAY_CANCEL_BOOKING)
    .map((action: Action) => action.payload)
    .switchMap((bookingId: number) => this.bookingService.sameDayCancel(bookingId)
      .map((booking: Booking) => ({ type: REPLACE_BOOKING, payload: booking }))
      .catch(() => Observable.of({ type: SAME_DAY_CANCEL_BOOKING_FAILURE }))
    )
    .share()

}



// WEBPACK FOOTER //
// /Users/jason/src/matrix/client/src/app/reducers/effects/booking.ts